"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var FireWallRulesListCtl = /** @class */ (function (_super) {
    __extends(FireWallRulesListCtl, _super);
    function FireWallRulesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_is_control_ip = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_control_ip; });
        _this.dk_ip_address = UIUtils_1.UIUtils.IProp2Str(function (o) { o.ip_address; });
        _this.dk_is_control_fingerprint = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_control_fingerprint; });
        _this.dk_fingerprint = UIUtils_1.UIUtils.IProp2Str(function (o) { o.fingerprint; });
        _this.dk_is_control_useragent = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_control_useragent; });
        _this.dk_useragent = UIUtils_1.UIUtils.IProp2Str(function (o) { o.useragent; });
        _this.dk_is_control_email_part = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_control_email_part; });
        _this.dk_email_part = UIUtils_1.UIUtils.IProp2Str(function (o) { o.email_part; });
        _this.dk_on_detect_action_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.on_detect_action_code; });
        _this.dk_on_detect_action_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.on_detect_action_title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_firewall_event_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.firewall_event_code; });
        _this.dk_firewall_event_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.firewall_event_title; });
        _this.dk_is_control_partner = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_control_partner; });
        _this.dk_pprogram_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pprogram_id; });
        _this.dk_pprogram_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pprogram_title; });
        _this.dk_usr_partner_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_partner_id; });
        _this.dk_usr_partner_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_partner_login; });
        _this.dk_on_detect_trust_zone_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.on_detect_trust_zone_code; });
        _this.dk_on_detect_trust_zone_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.on_detect_trust_zone_title; });
        _this.dk_on_detect_message_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.on_detect_message_code; });
        _this.dk_on_detect_message_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.on_detect_message_title; });
        _this.dk_is_control_suspicious_partners_only = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_control_suspicious_partners_only; });
        _this.dk_is_control_isp_provider = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_control_isp_provider; });
        _this.dk_isp_provider = UIUtils_1.UIUtils.IProp2Str(function (o) { o.isp_provider; });
        _this.dk_is_control_password = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_control_password; });
        _this.dk_password = UIUtils_1.UIUtils.IProp2Str(function (o) { o.password; });
        _this.dk_is_control_timezone_offset = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_control_timezone_offset; });
        _this.dk_timezone_offset = UIUtils_1.UIUtils.IProp2Str(function (o) { o.timezone_offset; });
        _this.dk_is_control_specified_country_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_control_specified_country_code; });
        _this.dk_specified_country_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.specified_country_code; });
        _this.dk_is_control_except_the_specified_country_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_control_except_the_specified_country_code; });
        _this.dk_except_the_specified_country_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.except_the_specified_country_code; });
        _this.dk_is_player_login_equal_password = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_player_login_equal_password; });
        _this._errDialog = errDialog;
        return _this;
    }
    FireWallRulesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    FireWallRulesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "firewall rule with id [" + id + "] not found !";
    };
    FireWallRulesListCtl.prototype.LoadData = function (AllBrands, BrandIdList, onDone) {
        var _this = this;
        webAApi_1.ListFireWallRulesByBrandIdGet.exec({ all_brands: AllBrands, brand_id_list: BrandIdList }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    is_control_ip: resp.list[i].is_control_ip,
                    ip_address: resp.list[i].ip_address,
                    is_control_fingerprint: resp.list[i].is_control_fingerprint,
                    fingerprint: resp.list[i].fingerprint,
                    is_control_useragent: resp.list[i].is_control_useragent,
                    useragent: resp.list[i].useragent,
                    is_control_email_part: resp.list[i].is_control_email_part,
                    email_part: resp.list[i].email_part,
                    on_detect_action_code: resp.list[i].on_detect_action_code,
                    on_detect_action_title: resp.list[i].on_detect_action_title,
                    description: resp.list[i].description,
                    is_locked: resp.list[i].is_locked,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    firewall_event_code: resp.list[i].firewall_event_code,
                    firewall_event_title: resp.list[i].firewall_event_title,
                    is_control_partner: resp.list[i].is_control_partner,
                    pprogram_id: resp.list[i].pprogram_id,
                    pprogram_title: resp.list[i].pprogram_title,
                    usr_partner_id: resp.list[i].usr_partner_id,
                    usr_partner_login: resp.list[i].usr_partner_login,
                    on_detect_trust_zone_code: resp.list[i].on_detect_trust_zone_code,
                    on_detect_trust_zone_title: resp.list[i].on_detect_trust_zone_title,
                    on_detect_message_code: resp.list[i].on_detect_message_code,
                    on_detect_message_title: resp.list[i].on_detect_message_title,
                    is_control_suspicious_partners_only: resp.list[i].is_control_suspicious_partners_only,
                    is_control_isp_provider: resp.list[i].is_control_isp_provider,
                    isp_provider: resp.list[i].isp_provider,
                    is_control_password: resp.list[i].is_control_password,
                    password: resp.list[i].password,
                    is_control_timezone_offset: resp.list[i].is_control_timezone_offset,
                    timezone_offset: resp.list[i].timezone_offset,
                    is_control_specified_country_code: resp.list[i].is_control_specified_country_code,
                    specified_country_code: resp.list[i].specified_country_code,
                    is_control_except_the_specified_country_code: resp.list[i].is_control_except_the_specified_country_code,
                    except_the_specified_country_code: resp.list[i].except_the_specified_country_code,
                    is_player_login_equal_password: resp.list[i].is_player_login_equal_password
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    FireWallRulesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddFireWallRule.exec({
            data: {
                brand_id: data.brand_id,
                description: data.description,
                is_locked: data.is_locked,
                is_control_ip: data.is_control_ip,
                ip_address: data.ip_address,
                is_control_fingerprint: data.is_control_fingerprint,
                fingerprint: data.fingerprint,
                is_control_useragent: data.is_control_useragent,
                useragent: data.useragent,
                on_detect_action_code: data.on_detect_action_code,
                is_control_email_part: data.is_control_email_part,
                email_part: data.email_part,
                firewall_event_code: data.firewall_event_code,
                is_control_partner: data.is_control_partner,
                pprogram_id: data.pprogram_id,
                usr_partner_id: data.usr_partner_id,
                on_detect_trust_zone_code: data.on_detect_trust_zone_code,
                on_detect_message_code: data.on_detect_message_code,
                is_control_suspicious_partners_only: data.is_control_suspicious_partners_only,
                is_control_isp_provider: data.is_control_isp_provider,
                isp_provider: data.isp_provider,
                is_control_password: data.is_control_password,
                password: data.password,
                is_control_timezone_offset: data.is_control_timezone_offset,
                timezone_offset: data.timezone_offset,
                is_control_specified_country_code: data.is_control_specified_country_code,
                specified_country_code: data.specified_country_code,
                is_control_except_the_specified_country_code: data.is_control_except_the_specified_country_code,
                except_the_specified_country_code: data.except_the_specified_country_code,
                is_player_login_equal_password: data.is_player_login_equal_password
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                is_control_ip: data.is_control_ip,
                ip_address: data.ip_address,
                is_control_fingerprint: data.is_control_fingerprint,
                fingerprint: data.fingerprint,
                is_control_useragent: data.is_control_useragent,
                useragent: data.useragent,
                is_control_email_part: data.is_control_email_part,
                email_part: data.email_part,
                on_detect_action_code: data.on_detect_action_code,
                on_detect_action_title: resp.on_detect_action_title,
                description: data.description,
                is_locked: data.is_locked,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                firewall_event_code: data.firewall_event_code,
                firewall_event_title: resp.firewall_event_title,
                is_control_partner: data.is_control_partner,
                pprogram_id: data.pprogram_id,
                pprogram_title: resp.pprogram_title,
                usr_partner_id: data.usr_partner_id,
                usr_partner_login: resp.usr_partner_login,
                on_detect_trust_zone_code: data.on_detect_trust_zone_code,
                on_detect_trust_zone_title: resp.on_detect_trust_zone_title,
                on_detect_message_code: data.on_detect_message_code,
                on_detect_message_title: resp.on_detect_message_title,
                is_control_suspicious_partners_only: data.is_control_suspicious_partners_only,
                is_control_isp_provider: data.is_control_isp_provider,
                isp_provider: data.isp_provider,
                is_control_password: data.is_control_password,
                password: data.password,
                is_control_timezone_offset: data.is_control_timezone_offset,
                timezone_offset: data.timezone_offset,
                is_control_specified_country_code: data.is_control_specified_country_code,
                specified_country_code: data.specified_country_code,
                is_control_except_the_specified_country_code: data.is_control_except_the_specified_country_code,
                except_the_specified_country_code: data.except_the_specified_country_code,
                is_player_login_equal_password: data.is_player_login_equal_password
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    FireWallRulesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditFireWallRule.exec({
                data: {
                    firewall_rule_id: data.key,
                    description: data.description,
                    is_locked: data.is_locked,
                    is_control_ip: data.is_control_ip,
                    ip_address: data.ip_address,
                    is_control_fingerprint: data.is_control_fingerprint,
                    fingerprint: data.fingerprint,
                    is_control_useragent: data.is_control_useragent,
                    useragent: data.useragent,
                    on_detect_action_code: data.on_detect_action_code,
                    is_control_email_part: data.is_control_email_part,
                    email_part: data.email_part,
                    firewall_event_code: data.firewall_event_code,
                    is_control_partner: data.is_control_partner,
                    pprogram_id: data.pprogram_id,
                    usr_partner_id: data.usr_partner_id,
                    on_detect_trust_zone_code: data.on_detect_trust_zone_code,
                    on_detect_message_code: data.on_detect_message_code,
                    is_control_suspicious_partners_only: data.is_control_suspicious_partners_only,
                    is_control_isp_provider: data.is_control_isp_provider,
                    isp_provider: data.isp_provider,
                    is_control_password: data.is_control_password,
                    password: data.password,
                    is_control_timezone_offset: data.is_control_timezone_offset,
                    timezone_offset: data.timezone_offset,
                    is_control_specified_country_code: data.is_control_specified_country_code,
                    specified_country_code: data.specified_country_code,
                    is_control_except_the_specified_country_code: data.is_control_except_the_specified_country_code,
                    except_the_specified_country_code: data.except_the_specified_country_code,
                    is_player_login_equal_password: data.is_player_login_equal_password
                }
            }, function (resp) {
                _tmp.description = data.description;
                _tmp.is_locked = data.is_locked;
                _tmp.is_control_ip = data.is_control_ip;
                _tmp.ip_address = data.ip_address;
                _tmp.is_control_fingerprint = data.is_control_fingerprint;
                _tmp.fingerprint = data.fingerprint;
                _tmp.is_control_useragent = data.is_control_useragent;
                _tmp.useragent = data.useragent;
                _tmp.is_control_email_part = data.is_control_email_part;
                _tmp.email_part = data.email_part;
                _tmp.on_detect_action_code = data.on_detect_action_code;
                _tmp.on_detect_action_title = resp.on_detect_action_title;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.firewall_event_code = data.firewall_event_code;
                _tmp.firewall_event_title = resp.firewall_event_title;
                _tmp.is_control_partner = data.is_control_partner;
                _tmp.pprogram_id = data.pprogram_id;
                _tmp.pprogram_title = resp.pprogram_title;
                _tmp.usr_partner_id = data.usr_partner_id;
                _tmp.usr_partner_login = resp.usr_partner_login;
                _tmp.on_detect_trust_zone_code = data.on_detect_trust_zone_code;
                _tmp.on_detect_trust_zone_title = resp.on_detect_trust_zone_title;
                _tmp.on_detect_message_code = data.on_detect_message_code;
                _tmp.on_detect_message_title = resp.on_detect_message_title;
                _tmp.is_control_suspicious_partners_only = data.is_control_suspicious_partners_only,
                    _tmp.is_control_isp_provider = data.is_control_isp_provider,
                    _tmp.isp_provider = data.isp_provider,
                    _tmp.is_control_password = data.is_control_password,
                    _tmp.password = data.password,
                    _tmp.is_control_timezone_offset = data.is_control_timezone_offset,
                    _tmp.timezone_offset = data.timezone_offset,
                    _tmp.is_control_specified_country_code = data.is_control_specified_country_code,
                    _tmp.specified_country_code = data.specified_country_code,
                    _tmp.is_control_except_the_specified_country_code = data.is_control_except_the_specified_country_code,
                    _tmp.except_the_specified_country_code = data.except_the_specified_country_code,
                    _tmp.is_player_login_equal_password = data.is_player_login_equal_password;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    FireWallRulesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    FireWallRulesListCtl.prototype.DeleteRule = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteFireWallRule.exec({
                data: { firewall_rule_id: key }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    FireWallRulesListCtl.prototype.doSetIsLocked = function (key, isLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetFireWallRuleIsLocked.exec({
                data: { firewall_rule_id: key, is_locked: isLocked }
            }, function (resp) {
                _tmp.is_locked = isLocked;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    FireWallRulesListCtl.prototype.doBlockAllPlayersCoveredByRule = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoLockAllPlayersCoveredByRule.exec({
                data: { firewall_rule_id: key }
            }, function (resp) {
                // _tmp.is_locked = isLocked;
                //_tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone(resp.locked_count);
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    FireWallRulesListCtl.prototype.getPlayersCoveredByRuleCount = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.GetPlayersCountCoveredByRule.exec({
                data: { firewall_rule_id: key }
            }, function (resp) {
                // _tmp.is_locked = isLocked;
                //_tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone(resp.covered_count);
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    FireWallRulesListCtl.prototype.getPlayersListCoveredByRule = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.ListPlayersAvailByFireWallRuleGet.exec({
                firewall_rule_id: key
            }, function (resp) {
                var dPlayersAll = [];
                var dPlayersAlive = [];
                for (var i = 0; i < resp.list.length; i++) {
                    dPlayersAll.push({
                        key: resp.list[i].key_uid,
                        value: resp.list[i].login
                    });
                    if (!resp.list[i].is_locked) {
                        dPlayersAlive.push({
                            key: resp.list[i].key_uid,
                            value: resp.list[i].login
                        });
                    }
                }
                // _tmp.is_locked = isLocked;
                //_tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone(resp.list.length, dPlayersAll, dPlayersAlive);
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return FireWallRulesListCtl;
}(BaseController_1.BaseController));
exports.FireWallRulesListCtl = FireWallRulesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/security_firewall/ctl/FireWallRulesListCtl.ts
// module id = 1036
// module chunks = 0